import { createContext, useState, useContext } from 'react';

export const InputFilePageContext   = createContext()
export const UseInputFile           = () => useContext(InputFilePageContext);

export const InputFilePageProvider  = ({ children }) => {

    const [ data,          setData         ] = useState([])
    const [ search,        setSearch       ] = useState(null);
    const [ loading,       isLoading       ] = useState(true)
    const [ demandDates,   setDemandDates  ] = useState(null)
    const [ isModalOpen,   setIsModalOpen  ] = useState(false);

    const [ selectedDemandPostId,    setSelectedDemandPostId ] = useState(null)
    const [ isDemandsModalOpen,      setIsDemandsModalOpen   ] = useState(false)
        
    const [ horizonTypes,            setHorizonTypes          ] = useState([])
    const [ selectedHorizonTypeId,   setSelectedHorizonTypeId ] = useState(null)
    const [ selectedDate,            setSelectedDate          ] = useState(null);
    
    const [ updateDatepicker,        setUpdateDatepicker      ] = useState(false)
    const [ updateDemandTable,       setUpdateDemandTable     ] = useState(false) 

    const handleModalFileOpen     = () => setIsModalOpen(true)
    const handleModalFileClose    = () => setIsModalOpen(false)

    const handleDemandsModalOpen  = () => setIsDemandsModalOpen(true)
    const handleDemandsModalClose = () => setIsDemandsModalOpen(false)

    const handleUpdateDemandTable = () => setUpdateDemandTable(!updateDemandTable)
    const handleUpdateDatepicker  = () => setUpdateDatepicker(!updateDatepicker)
    
    const value = {
        
        //InputFileTable
        selectedDemandPostId, 
        setSelectedDemandPostId,
        handleUpdateDemandTable,
        updateDemandTable,

        //Datepicker
        handleUpdateDatepicker,
        updateDatepicker,

        //TableFileFilter
        setSelectedDate, 
        selectedDate,
        search,
        setSearch, 

        //InputFileForm
        isModalOpen,
        handleModalFileOpen,
        handleModalFileClose,

        //DemandsTableModal
        demandDates, 
        setDemandDates,
        isDemandsModalOpen,
        handleDemandsModalOpen,
        handleDemandsModalClose,
        loading, 
        isLoading,
        data,
        setData,

        //InputFilePageHorizonFilter
        horizonTypes,
        setHorizonTypes,
        selectedHorizonTypeId,
        setSelectedHorizonTypeId

    }

    return (

        <InputFilePageContext.Provider value={value}>
            {children}
        </InputFilePageContext.Provider>
        
    )
}